module.exports = "/assets/data/5a397621f543390228353763bd77353c-CO5.data.json";